export const TIPO_DIA = {
  HABIL: 1,
  DESCANSO1: 2,
  DESCANSO2: 3,
  FESTIVO: 4
};

export const TIPO_DIA_OPTIONS = [
  { value: 1, text: 'Hábil' },
  { value: 2, text: 'Descanso1' },
  { value: 3, text: 'Descanso2' },
  { value: 4, text: 'Festivo' }
];